import { FC } from "react";

import { useCrudNavigate } from "@ryde/redux";
import {
  DrawerType,
  EditFormMode,
  RydeAppUnit,
  RydeUiUnit,
} from "@ryde/shared";

import { DrawerNewOrDuplicate } from "../drawers";

interface IEditFormGeneric {
  entity: RydeUiUnit;
}

export const AddNewFormGeneric: FC<IEditFormGeneric> = ({ entity }) => {
  const { navigateToList, navigateToAddOrDuplicate } = useCrudNavigate(
    entity as RydeAppUnit,
  );

  return (
    <DrawerNewOrDuplicate
      type={DrawerType.NewOrDuplicate}
      entity={entity}
      mode={EditFormMode.CrudRoute}
      onCloseDrawer={navigateToList}
      onCreateCustomAction={navigateToAddOrDuplicate}
    />
  );
};
